__turbopack_context__.v({
  "container": "LZuJNW_container",
  "resume": "LZuJNW_resume",
  "resume_embed": "LZuJNW_resume_embed",
  "title": "LZuJNW_title",
});
